import { Paper, styled } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export const SideDrawerPaper = ({ children }: Props) => {
  return <StyledPaper>{children}</StyledPaper>;
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 0,
  borderLeft: `1px solid ${theme.vars.palette.divider}`,
  overflow: 'auto',
  width: 500,
  minWidth: 500,
  maxWidth: 500,
  display: 'flex',
  flexGrow: '1',
  flexDirection: 'column',
}));
